module.exports = __webpack_public_path__ + "static/media/COS_SERVIER.4a8ae94a.jpg";